import { useMemo } from 'external/react'

import usePayment from 'context/payment-context/hook'

import PackageCourse from './PackageCourse'
import RemovePackage from './RemovePackage'

export default function Packages() {

    const {packageItem} = usePayment()

    const [hasPackage, {offerName, courses}] = useMemo(() => [!!packageItem, (packageItem || {}) as any], [packageItem])

    return (
        <div className='col-md-8'>
            {hasPackage && (
                <div className='accordion mb-2' id='accordionPanelsStayOpenExample' key={offerName}>
                    <div>
                    <div className='d-flex justify-content-between ml-2 mr-2'>
                        <span className='text-capitalize' style={{ fontSize: '18px', color: '#1797D0', fontWeight: 'bold', }}>{offerName}</span>
                        <RemovePackage />
                   </div>
                    <div className='accordion-body'>
                        {courses.map((course, index) => (<PackageCourse key={index} course={course} />))}
                   </div>
                </div>
            </div>)}
        </div>
    )
}